import './TeamMemberCard.css'; // Import the necessary styles
import { tTeamMember } from '../data/Team';
import { getBorderColor } from '../helper/HelperFunctions';

enum eJobTitle {
    Trainee = 0.25,
    JuniorDeveloper = 0.5,
    JuniorSoftwareDeveloper = 0.75,
    Developer = 1,
    SoftwareEngineer = 1.25,
    SeniorSoftwareDeveloper = 1.5,
    LeadDeveloper = 1.75  
}

interface TeamMemberCardProps {
    member: tTeamMember;
    onClickCallback?: (memberId: number) => void;
}

export default function TeamMemberCard(props: TeamMemberCardProps) {
    const borderColor = getBorderColor(props.member.skill);

    const handleClick = () => {
        if (props.onClickCallback) {
            props.onClickCallback(props.member.id);
        }
    };

    return (
        <div className="team-member-card" style={{ borderColor, cursor: props.onClickCallback ? 'pointer' : 'default' }} onClick={handleClick}>
            <div className="icon">{props.member.icon}</div>
            <h3>{props.member.name}</h3>
            <h5>{getJobTitleForSkillLevel(props.member.level)}</h5>

            {/* Popup with more info on hover */}
            <div className="popup" style={{ borderColor }}>
                <h3>{props.member.name}</h3>
                <h5>{getJobTitleForSkillLevel(props.member.level)}</h5>
                <hr style={{margin: '4px'}}/>
                <p>{props.member.description}</p>
            </div>
        </div>
    );
};

//#region job title
function getJobTitleForSkillLevel(skillLevel: number): string {
    if (skillLevel >= eJobTitle.Trainee && skillLevel < eJobTitle.JuniorDeveloper) {
        return "Trainee";
    } else if (skillLevel >= eJobTitle.JuniorDeveloper && skillLevel < eJobTitle.JuniorSoftwareDeveloper) {
        return "Junior Developer";
    } else if (skillLevel >= eJobTitle.JuniorSoftwareDeveloper && skillLevel < eJobTitle.Developer) {
        return "Junior Software Developer";
    } else if (skillLevel === eJobTitle.Developer) {
        return "Developer";
    } else if (skillLevel > eJobTitle.Developer && skillLevel <= eJobTitle.SoftwareEngineer) {
        return "Software Engineer";
    } else if (skillLevel > eJobTitle.SoftwareEngineer && skillLevel <= eJobTitle.SeniorSoftwareDeveloper) {
        return "Senior Software Developer";
    } else if (skillLevel > eJobTitle.SeniorSoftwareDeveloper && skillLevel <= eJobTitle.LeadDeveloper) {
        return "Lead Developer";
    } else {
        return "Unknown Skill Level"; // In case the skill level is outside the expected range
    }
}
